import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M18.75 5.25V18.75C18.75 19.9875 17.7375 21 16.5 21C15.2625 21 14.25 19.9875 14.25 18.75V5.25C14.25 4.0125 15.2625 3 16.5 3C17.7375 3 18.75 4.0125 18.75 5.25ZM7.5 3C6.2625 3 5.25 4.0125 5.25 5.25V18.75C5.25 19.9875 6.2625 21 7.5 21C8.7375 21 9.75 19.9875 9.75 18.75V5.25C9.75 4.0125 8.7375 3 7.5 3Z' />
        </SvgIcon>
    );
});
